import React, { useEffect, useState } from 'react';
import InfoDialog from '../../../../components/shared/InfoDialog';
import LoaderContainer from '../../../../components/material-ui/loader_container/LoaderContainer';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Card from '../../../../components/material-ui/adaptive/Card';
import { IconCopy } from '@tabler/icons-react';
import CusButton from '../../../../components/material-ui/CusButton';
import useToast from '../../../../hooks/useToast';
import { API_FINANCE } from '../../../../api/finance';

export default function DepositGatewayReplies({ openRawId, depositInfo, setOpenRawId }) {
  const { t } = useTranslation();
  const { infoToast } = useToast();
  const [reply, setReply] = useState(undefined);
  const gate = depositInfo[8];

  useEffect(() => {
    if (!openRawId) return;
    if (!gate) return;

    setReply(undefined);

    API_FINANCE.deposit
      .raws({ invoiceId: openRawId, gate: gate })
      .then((e) => {
        const data = e.data.data;
        setReply(data);
      })
      .catch((e) => {
        console.log(e);
        setReply({});
      });
  }, [openRawId, gate]);

  return (
    <InfoDialog
      open={openRawId}
      maxWidth="lg"
      onClose={() => {
        setOpenRawId(null);
        setReply(null);
      }}>
      <LoaderContainer loader={!reply}>
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} gap={3}>
          <Box>
            <Typography component={'span'} fontWeight={600}>
              {t('Transaction ID')}:
            </Typography>{' '}
            <Typography component={'span'}>{depositInfo?.[1]}</Typography>
          </Box>
        </Stack>
        <Card>
          <pre
            style={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              maxHeight: '50svh',
              overflow: 'auto'
            }}>
            {JSON.stringify(reply, null, 2)}
          </pre>
          <Stack mt={1}>
            <CusButton
              onClick={() => {
                navigator.clipboard.writeText(JSON.stringify(reply, null, 2)).then((e) => {
                  infoToast('copied to your clipboard');
                });
              }}>
              <IconCopy />
            </CusButton>
          </Stack>
        </Card>
      </LoaderContainer>
    </InfoDialog>
  );
}
